import client from "../config/AxiosConfig";

export const GetContentByCategory = async id =>
  client.get(`/content/category/${id}`);

export const GetNextWeddings = async () =>
  client.get('/content/weddings');